import { lazy, Suspense, useEffect } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/kangaroo.css";
import "./assets/fonts/fonts.css";

// Eagerly load critical components
import ScrollToTop from "./component/ScrollTop/ScrollToTop";
import MainLayout from "./page/Layout/MainLayout";
import GeneralPage from "./pages/GeneralPage/Page/generalPage";
import ScoreCalculator from "./pages/Calculator/page/ScoreCalculator";
import IELTSScoreCalculator from "./pages/Calculator/component/IELTSCalculator";
import PTEScoreCalculator from "./pages/Calculator/component/PTEScoreCalculator";
import NEBGPACalculator from "./pages/Calculator/component/NEBGrade";
import SEEGPACalculator from "./pages/Calculator/component/SEEGPACalculator";
import GPAToPercentageCalculator from "./pages/Calculator/component/GPAtoPercentage";
import PageDetails from "./page/PageTypeTheme/PageDetail";
import ThemeDetail from "./page/Theme/ThemeDetail";
import Privacy from "./pages/PrivacyPage/page/Privacy";
import { RotatingTriangles } from "react-loader-spinner";
import Professional from "./Homepage/Professional";
import SectionContainer from "./Homepage/SectionContainer";
import Testimonial from "./pages/TestimonialPage/page/Testimonial";
import AboutMessage from "./pages/AboutPage/page/AboutMessage";
import { Toaster } from "react-hot-toast";
import Login from "./pages/Authentication/Login";
import ProtectedRoute from "./ProtectedRoute";
import Register from "./pages/Authentication/Register";
import Courses from "./pages/CampusPage/Courses";
import CourseDetail from "./pages/CampusPage/CourseDetail";
import Certificate from "./common/Certificate/Certificate";
import CertificateExport from "./common/Certificate/CertificateExport";
import ForgotPassword from "./pages/Authentication/Forgotpassword";
import ResetPassword from "./pages/Authentication/ResetPassword";
import ChangePassword from "./pages/Authentication/ChangePassword";
import UserProfile from "./pages/UserProfilePage/page/UserProfile";
import Backup from "./common/Certificate/Backup";
import BrandHomepage from "./BrandIdentity/pages/BrandIdentityHomepage/BrandHomepage";
import BrandIndentity from "./BrandIdentity/pages/BrandIdentityHomepage/page/BrandIndentity";
import Brand from "./BrandIdentity/pages/BrandIdentityHomepage/page/brand/Brand";
import Identity from "./BrandIdentity/pages/BrandIdentityHomepage/page/Identity/Identity";
import Guideline from "./BrandIdentity/pages/BrandIdentityHomepage/page/guideline/Guideline";
import Artwork from "./BrandIdentity/pages/BrandIdentityHomepage/page/ArtworkAsstes/Artwork";

// Lazy load page components
const Homepage = lazy(() => import("./Homepage/Homepage"));
const JoinSuccess = lazy(() => import("./Homepage/JoinSuccess"));
const Page3 = lazy(() => import("./Homepage/LearnMore"));
const About = lazy(() => import("./pages/AboutPage/page/About"));
const TestPreparation = lazy(
  () => import("./pages/TestPreparationPage/page/TestPreparation"),
);
const Ielts = lazy(() => import("./pages/IeltsPage/page/Ielts"));
const InstitutionPage = lazy(
  () => import("./pages/InstitutionPage/page/InstitutionPage"),
);
const CountryPage = lazy(() => import("./pages/CountryPage/page/CountryPage"));
const AboutLanding = lazy(() => import("./pages/AboutPage/page/AboutLanding"));
const InstitutionRepresent = lazy(
  () => import("./pages/InstitutionWeRepresent/page/InstitutionRepresent"),
);
const Destination = lazy(
  () => import("./pages/DestinationPage/page/Destination"),
);
const CareerLanding = lazy(
  () => import("./pages/CareerPage/page/CareerLanding"),
);
const AboutPartner = lazy(() => import("./pages/AboutPage/page/AboutPartner"));
const AboutMilestone = lazy(
  () => import("./pages/AboutPage/page/AboutMilestone"),
);
const CareerDetail = lazy(() => import("./pages/CareerPage/page/CareerDetail"));
const Blog = lazy(() => import("./pages/BlogPage/page/Blog"));
const BlogLanding = lazy(() => import("./pages/BlogPage/page/BlogLanding"));
const Event = lazy(() => import("./pages/EventPage/page/Event"));
const EventDetail = lazy(() => import("./pages/EventPage/page/EventDetail"));
const Franchise = lazy(() => import("./pages/FranchisePage/page/Franchise"));
const Contact = lazy(() => import("./pages/ContactPage/page/Contact"));
const Getfreecounseling = lazy(
  () => import("./pages/GetFreeCounseling/page/Getfreecounseling"),
);
const FranchiseHidden = lazy(
  () => import("./pages/FranchisePage/page/FranchiseHidden"),
);

// Loading fallback component
const LoadingFallback = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "60vh",
      fontSize: "1.2rem",
      color: "#666",
    }}
  >
    <RotatingTriangles
      visible={true}
      height="80"
      width="80"
      color="#4fa94d"
      ariaLabel="rotating-triangles-loading"
      wrapperStyle={{}}
      wrapperClass=""
    />
  </div>
);

function App() {
  // useEffect(() => {
  //   // Add class to disable all interactions including hover
  //   document.body.classList.add("no-hover");
  //   document.body.style.pointerEvents = "none";

  //   const timer = setTimeout(() => {
  //     document.body.classList.remove("no-hover");
  //     document.body.style.pointerEvents = "auto";
  //   }, 2200);

  //   return () => {
  //     clearTimeout(timer);
  //     document.body.classList.remove("no-hover");
  //     document.body.style.pointerEvents = "auto";
  //   }asd;
  // }, []);

  const ProtectedRoute = () => {
    const user = localStorage.getItem("user"); // or your auth logic
    if (!user) {
      return <Navigate to="/login" replace />;
    }
    return <Outlet />;
  };

  const PublicRoute = () => {
    const user = localStorage.getItem("user");
    if (user) {
      return <Navigate to="/" replace />;
    }
    return <Outlet />;
  };

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<BrandHomepage />} />
              <Route path="/brand-identity-guideline" element={<BrandIndentity />} />
              <Route path="/brand-identity-guideline/brand" element={<Brand />} />
              <Route path="/brand-identity-guideline/identity" element={<Identity />} />
              <Route path="/brand-identity-guideline/guideline" element={<Guideline />} />
              <Route path="/artwork" element={<Artwork />} />
            </Route>
          </Route>




        </Routes>
      </Suspense>
      <Toaster />
    </>
  );
}

export default App;
